import { action } from "typesafe-actions";

import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { IUserDocument } from "./userDocument.types";
import { IStoreState } from "../initialStoreState";
import { api } from "../../api/api";
import {
	saveLoaderCompleted,
	saveLoaderProgress,
	showMessage,
} from "../messages/messagesActions";
import { uploadFile, uploadUserFile } from "../../helpers/uploadFile";

export const FETCH_USER_DOCUMENTS_LIST_PROGRESS =
	"FETCH_USER_DOCUMENTS_LIST_PROGRESS";
export const FETCH_USER_DOCUMENTS_LIST_SUCCESS =
	"FETCH_USER_DOCUMENTS_LIST_SUCCESS";
export const FETCH_USER_DOCUMENTS_LIST_FAILED =
	"FETCH_USER_DOCUMENTS_LIST_FAILED";

export const fetchUserDocumentsListProgress = () =>
	action(FETCH_USER_DOCUMENTS_LIST_PROGRESS);
export const fetchUserDocumentsListSuccess = (
	data: IUserDocument[],
	totalRecords?: number
) => action(FETCH_USER_DOCUMENTS_LIST_SUCCESS, { data, totalRecords });
export const fetchUserDocumentsListFailed = () =>
	action(FETCH_USER_DOCUMENTS_LIST_FAILED);

export const fetchUserDocumentsListAsync =
	(
		user_id: string,
		page: number,
		rowsPerPage: number
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch, getState) => {
			try {
				dispatch(fetchUserDocumentsListProgress());
				let url = `/user/get-user-attachment?pageNo=${page}&itemPerPage=${rowsPerPage}`;
				if (user_id) {
					url += `&user_id=${user_id}&user_uuid=${user_id}`;
				}
				const res = await api.get(url);
				const rawData: any[] = res?.data?.data || [];
				const data: IUserDocument[] = rawData.map((item) => {
					const fileUrl =
						item.file_url ||
						(Array.isArray(item.attachments) && item.attachments.length > 0
							? item.attachments[0]
							: item.attachment) ||
						item.url ||
						item.path ||
						"";
					const docType = item.document_type || item.type || "";
					return {
						...item,
						file_url: fileUrl,
						document_type: docType,
					};
				});
				const totalRecords =
					res?.data?.totalRecords ??
					res?.data?.total_record ??
					res?.data?.count ??
					data.length;
				dispatch(fetchUserDocumentsListSuccess(data, totalRecords));
			} catch (err: any) {
				dispatch(fetchUserDocumentsListFailed());
				dispatch(
					showMessage({
						type: "error",
						message: err?.response?.data?.message || "Failed to fetch user documents",
						displayAs: "snackbar",
					})
				);
			}
		};

export const addUserDocumentsAsync =
	(
		data: IUserDocument,
		file: any | null,
		onCallback: (isSuccess: boolean, path?: string) => void
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch, getState) => {
			try {
				dispatch(saveLoaderProgress());

				const path = file
					? await uploadUserFile(file, data.file_url || "")
					: data.file_url || "";

				const payload = {
					user_attachments_uuid:
						data.user_attachments_uuid || data.user_attachment_uuid || "",
					user_uuid: data.user_uuid || data.user_id || "",
					description: data.description || "",
					attachments: path
						? [path]
						: data.attachments && data.attachments.length
							? data.attachments
							: [null],
					status: "ACTIVE",
					company_outlet_uuid: data.company_outlet_uuid || "",
					type: data.document_type || "",
					// description: data.description || "",
				};

				await api.post("/user/upsert-user-attachment", payload);

				dispatch(saveLoaderCompleted());
				dispatch(
					showMessage({
						type: "success",
						message: "Document saved successfully!",
						displayAs: "snackbar",
					})
				);
				onCallback(true, path);
			} catch (err: any) {
				onCallback(false, "");
				dispatch(
					showMessage({
						type: "error",
						message: err?.response?.data?.message || "Failed to upload document",
						displayAs: "snackbar",
					})
				);
			}
		};
